import { render } from "./update.vue?vue&type=template&id=5f3251b3&scoped=true&ts=true"
import script from "./update.vue?vue&type=script&lang=ts"
export * from "./update.vue?vue&type=script&lang=ts"

import "./update.vue?vue&type=style&index=0&id=5f3251b3&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3251b3"]])

export default __exports__